import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';
import { CreateSavedFilter } from 'dataSources/Typicode/savedFilters';
import { STATUS_LOADING } from 'common/constants';
import { Filter } from 'pages/Map/components/FilterModal/context/filter/hooks/useGetFilter';

const action = (
  state: IState,
  payloadAction: PayloadAction<
    CreateSavedFilter & { normalizedFilter: Filter }
  >,
) => {
  const { id, ...rest } = payloadAction.payload;

  state.savedFilters.data = {
    ...state.savedFilters.data,
    [id]: {
      id,
      statusLoading: STATUS_LOADING.load,
      ...rest,
    },
  };
};

export default action;
